import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import RmvendorDashboard from '../RmvendorDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function RmvendorPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < RmvendorDashboard />
    )

}